import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = { class: "form-group group1" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_5 = { class: "small" }

import {
  reactive,
  useTemplateRef,
} from 'vue';
import axios from 'axios';
import { clearSession, setToken } from 'src/services/session';
import { useAuth } from 'src/composables/useAuth';

const CREDENTIAL_ERROR_MESSAGE = 'ログインIDまたはパスワードが間違っています';
const UNEXPECTED_ERROR_MESSAGE = 'ログインに失敗しました。時間をおいて再度お試しください';

// 認証情報の誤りとしてユーザーに提示するステータス（バックエンドは401を返すが、
// バリデーションエラー化された場合に備えて422も同様に扱う）
type LoginErrorMessage =
  | typeof CREDENTIAL_ERROR_MESSAGE
  | typeof UNEXPECTED_ERROR_MESSAGE
  | null;

interface LoginState {
 loginForm: {
    username: string;
    password: string;
  };
  errorMessage: LoginErrorMessage;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const CREDENTIAL_ERROR_STATUSES = [401, 422];

const state = reactive<LoginState>({
  loginForm: {
    username: '',
    password: '',
  },
  errorMessage: null,
});
// methods
// iOSのchromeだとautofillでchangeが効かないぽいのでがんばる
const refTextInputUsername = useTemplateRef<HTMLInputElement>('refTextInputUsername');
const refTextInputPassword = useTemplateRef<HTMLInputElement>('refTextInputPassword');
const ensureLoginFormValuesSynced = () => {
  const username = refTextInputUsername.value?.value;
  const password = refTextInputPassword.value?.value;
  state.loginForm.username = username || '';
  state.loginForm.password = password || '';
};
const auth = useAuth();

const tryLogin = async(): Promise<void> => {
  state.errorMessage = null;
  ensureLoginFormValuesSynced();

  // loginしようとするときは明示的に消す.
  // expiredなトークンを送り続けるとログインできないので.
  clearSession();

  try {
    const response = await auth.login(state.loginForm);
    if ('twoFactorUrl' in response) {
      location.href = response.twoFactorUrl + '&subsystem_name=movie-pf';
    } else if ('accessToken' in response) {
      setToken(response.accessToken);
      location.href = '/';
    }
  } catch (e) {
    const status = axios.isAxiosError(e) ? e.response?.status : null;
    if (status && CREDENTIAL_ERROR_STATUSES.includes(status)) {
      state.errorMessage = CREDENTIAL_ERROR_MESSAGE;
      return;
    }
    // ネットワークエラーや5xxなど想定外の失敗はログを残し、汎用メッセージを表示する
    console.error('login failed', e);
    state.errorMessage = UNEXPECTED_ERROR_MESSAGE;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "動画共有システム", -1)),
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _withModifiers(tryLogin, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            ref_key: "refTextInputUsername",
            ref: refTextInputUsername,
            placeholder: "ログインID",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.loginForm.username) = $event))
          }, null, 512), [
            [_vModelText, state.loginForm.username]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "form-control",
            ref_key: "refTextInputPassword",
            ref: refTextInputPassword,
            placeholder: "パスワード",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.loginForm.password) = $event))
          }, null, 512), [
            [_vModelText, state.loginForm.password]
          ]),
          (state.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(state.errorMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary btn-lg"
        }, [
          _createElementVNode("i", { class: "fas fa-sign-in-alt" }),
          _createTextVNode(" ログイン ")
        ], -1))
      ], 32)
    ])
  ]))
}
}

})